<template>
	<div class="table-responsive paginated-table" v-if="data.length">
		<table class="table bg-white table-hover">
			<thead>
				<tr>
					<th scope="col"
						v-for="(column, name) in columns"
						:key="`th_${name}`"
						:class="[{
							'sortable': column.sortable},
							`priority-${column.priority || 0}`,
							`text-${column.align || 'left'}`
						]"
						@click="column.sortable ? changeSort(name) : null"
					>
						<span class="text-nowrap">{{ column.label }}</span>
						<font-awesome-icon
							v-if="value._sort == name"
							:icon="value._asc === 1 ? 'angle-up' : 'angle-down'"
						/>
					</th>
				</tr>
			</thead>
			<tbody>
				<tr v-for="(item, i) in data" :key="`row-${i}-${item.id}`" :class="{ clickable: clickRow }" @click="rowDetail(item)">
					<td v-for="(column, name) in columns"
						:key="`td_${item.id}_${name}`"
						:class="[{
							'sortable': column.sortable},
							`priority-${column.priority || 0}`,
							`text-${column.align || 'left'}`
						]"
					>
						<slot v-if="$scopedSlots[name]" :name="name" v-bind:row="item" />
						<template v-else>
							{{item[name]}}
						</template>
					</td>
				</tr>
			</tbody>
		</table>
		<paginated-footer :data="data" v-model="value" :total="total" @changePage="changePage"></paginated-footer>
	</div>
	<span v-else>
		<div class="alert alert-info">
			Nessun record trovato.
		</div>
	</span>
</template>

<script>
import Paginated from './Paginated.vue'

export default {
    extends: Paginated,
    name: 'PaginatedTable',
    props: {
        clickRow: {
            type: Boolean,
            default: false
        }
    },
    methods: {
        rowDetail (row) {
            if (this.clickRow) this.$emit('rowClicked', row)
        }
    },
    components: {
        paginatedFooter: () => import('./PaginatedFooter.vue')
    }
}
</script>
<style lang="scss" scoped>
.clickable {
    cursor: pointer;
}
</style>
